import { useEffect, useRef, useState } from 'react'
import { useAuth } from '@shared/state/AuthContext'
import { initials } from './initials'

export function UserMenu() {
  const { user, signOut } = useAuth()
  const [open, setOpen] = useState(false)
  const wrapperRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!open) return

    function handlePointerDown(event: MouseEvent) {
      if (!wrapperRef.current?.contains(event.target as Node)) setOpen(false)
    }
    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') setOpen(false)
    }

    document.addEventListener('mousedown', handlePointerDown)
    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('mousedown', handlePointerDown)
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [open])

  if (!user) return null

  return (
    <div className="user-menu" ref={wrapperRef}>
      <button
        type="button"
        className="user-menu__avatar"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label={`Account: ${user.displayName}`}
        onClick={() => setOpen((value) => !value)}
      >
        <span className="user-menu__initials">{initials(user.displayName, user.email)}</span>
      </button>

      {open ? (
        <div className="user-menu__panel" role="menu">
          <div className="user-menu__identity">
            <span className="user-menu__name">{user.displayName}</span>
            <span className="user-menu__email">{user.email}</span>
            <span className="user-menu__role">{user.role}</span>
          </div>
          <button
            type="button"
            role="menuitem"
            className="user-menu__item"
            onClick={() => void signOut()}
          >
            Sign out
          </button>
        </div>
      ) : null}
    </div>
  )
}
